/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Run_Risk_ExternalInputs */



/**
* | output |
* | --- |
* | "External action" |
*
* @param {Agent_Run_Risk_ExternalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_run_risk_external = /** @type {((inputs?: Agent_Run_Risk_ExternalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Run_Risk_ExternalInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Externe Aktion")
	return /** @type {LocalizedString} */ ("External action")
});